/* RGB Illuminations — standard product main-gallery navigation.
   Mirrors the approved PrismTide previous/next behaviour while leaving Shopify
   media, thumbnails, video, variants, product forms, cart and checkout native. */
(() => {
  const DESKTOP = window.matchMedia('(min-width: 750px)');

  const bindGallery = (gallery) => {
    const viewer = gallery.querySelector('slider-component[id^="GalleryViewer-"]');
    const list = viewer?.querySelector(':scope > .product__media-list');
    const controls = viewer?.querySelector(':scope > .slider-buttons');
    const previous = controls?.querySelector('button[name="previous"]');
    const next = controls?.querySelector('button[name="next"]');

    if (!viewer || !list || !controls || !previous || !next || viewer.dataset.rgbMainNavBound === 'true') return;
    viewer.dataset.rgbMainNavBound = 'true';

    const getItems = () => Array.from(list.querySelectorAll(':scope > [data-media-id]'));

    const getState = () => {
      const items = getItems();
      const activeIndex = items.findIndex((item) => item.classList.contains('is-active'));
      return { items, index: activeIndex < 0 ? 0 : activeIndex };
    };

    const sync = () => {
      const { items, index } = getState();
      const current = controls.querySelector('.slider-counter--current');
      const total = controls.querySelector('.slider-counter--total');

      if (current) current.textContent = String(index + 1);
      if (total) total.textContent = String(items.length);

      if (DESKTOP.matches) {
        previous.disabled = index <= 0;
        next.disabled = index >= items.length - 1;
      }
    };

    const move = (direction) => (event) => {
      /* Mobile keeps Shopify's native swipe/slider interaction. Desktop uses
         setActiveMedia so the visible image changes exactly like PrismTide. */
      if (!DESKTOP.matches) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const { items, index } = getState();
      const targetIndex = Math.max(0, Math.min(items.length - 1, index + direction));
      if (targetIndex === index) {
        sync();
        return;
      }

      const target = items[targetIndex];
      const mediaId = target?.dataset.mediaId;
      if (mediaId && typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(mediaId, false);
        requestAnimationFrame(sync);
      }
    };

    previous.addEventListener('click', move(-1), { capture: true });
    next.addEventListener('click', move(1), { capture: true });

    const observer = new MutationObserver(() => requestAnimationFrame(sync));
    observer.observe(list, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });

    const onModeChange = () => {
      if (DESKTOP.matches) {
        sync();
      } else if (typeof viewer.resetPages === 'function') {
        viewer.resetPages();
      }
    };

    if (typeof DESKTOP.addEventListener === 'function') {
      DESKTOP.addEventListener('change', onModeChange);
    } else if (typeof DESKTOP.addListener === 'function') {
      DESKTOP.addListener(onModeChange);
    }

    sync();
  };

  const initRoot = (root) => {
    if (!root || root.dataset.rgbMediaNavEnhanced === 'true') return;
    root.dataset.rgbMediaNavEnhanced = 'true';
    root.querySelectorAll('media-gallery[id^="MediaGallery-"]').forEach(bindGallery);
  };

  const initAll = () => document.querySelectorAll('product-info.rgb-premium-universal').forEach(initRoot);

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('product-info:loaded', (event) => {
    const root = event.target?.matches?.('product-info.rgb-premium-universal') ? event.target : null;
    if (root) initRoot(root);
  });
  initAll();
})();
